import { client } from './Client';
import { useFirestoreNoCompagny, useFirestoreAllIn } from '../firebase/useFirestore';

/**
 * Parent portfolios of the current org, from CompagnyMeta.Parent. Shared by
 * the add-choosers (portfolio options) and the linked badges (name lookup).
 *
 * @returns {{parentPortfolioIds: Array<string>, portfolioNameById: Record<string, string>}}
 */
const useParentPortfolios = () => {
    const projectMetaRows = useFirestoreNoCompagny('CompagnyMeta', 'CompagnyID', client);
    const parentPortfolioIds = (Array.isArray(projectMetaRows) && projectMetaRows[0]?.Parent)
        ? projectMetaRows[0].Parent.filter(Boolean)
        : [];
    const parentPortfolioMetas = useFirestoreAllIn('CompagnyMeta', 'CompagnyID', parentPortfolioIds);
    const portfolioNameById = (parentPortfolioMetas || []).reduce((acc, meta) => {
        if (meta?.CompagnyID) acc[meta.CompagnyID] = meta.CommunityName;
        return acc;
    }, {});

    return { parentPortfolioIds, portfolioNameById };
};

export default useParentPortfolios;
